'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = Divider;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function Divider(_ref) {
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? '' : _ref$className;
  var _ref$style = _ref.style;
  var style = _ref$style === undefined ? {} : _ref$style;

  return _react2['default'].createElement('hr', {
    className: (0, _classnames2['default'])('paper-divider', className),
    style: Object.assign({
      border: 0,
      height: '1px',
      margin: '16px 0'
    }, style)
  });
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/divider.js
// module id = 327
// module chunks = 0